import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// REMOVED React.StrictMode - causes TradingView widget to initialize twice
// StrictMode is great for development but problematic with TradingView
root.render(
	<App />
);

// Optional: Send performance metrics to analytics
reportWebVitals((metric) => {
	// Log only in development
	if (process.env.NODE_ENV === 'development') {
		console.log(metric);
	}
	
	// TODO: Send to analytics service in production
	// Example: sendToAnalytics(metric);
});
